import { useTranslation } from 'react-i18next';
import styled from "styled-components";
import H1 from "../Atoms/H1";
import React from 'react';
import * as api from '../../api';
import { Link } from 'react-router-dom';
import Section from '../Atoms/Section';
import MiniatureContainer from '../Atoms/MiniatureContainer';
import Miniature from '../Atoms/Miniature';
import CityCommaCountry from '../Utils/CityCommaCountry';
import GetProjectMainImage from '../Utils/GetProjectMainImage';
import Spinner from '../../Plateforme/Atoms/Spinner';
import Select from '../Atoms/Select';
import { CountrySelectOptions, clientèles, positionnements, typologiesEspace, typologiesObjet } from '../Utils/Listings';
import FormatActivité from '../Utils/FormatActivité';
import BigH1 from '../Atoms/BigH1';
import { userHasFullAccess } from '../Utils/Validator';
import Searchbar from '../Components/Searchbar';

// const SearchFieldContainer = styled.div`
//     form {
//         position: relative;
        
//         input {
//             width: 100%;
//             border: 0;
//             padding: 0;
//             margin: 0;
//             outline: none;
//             background-color: transparent;
//             font-size: 55px;
//             font-weight: 600;

//             @media (max-width: 1000px) {
//                 font-size: 25px;
//             }

//             ::placeholder {
//                 color: blue;
//             }
//         }

//         img {
//             display: ${props => props.searchFieldContent ? "none" : "block"};
//             width: 40px;
//             padding: 0;
//             margin: 0;
//             position: absolute;
//             left: ${props => props.lang === "fr" ? "356px" : "242px"};
//             top: 50%;
//             transform: translateY(-50%);
//             pointer-events: none;

//             @media (max-width: 1000px) {
//                 width: 20px;
//                 left: ${props => props.lang === "fr" ? "163px" : "110px"};
//             }

//             @media (max-width: 1000px) {
//                 display: none;
//             }
//         }

//         img.loupe-mobile {
//             display: none;

//             @media (max-width: 1000px) {
//                 display: block;
//                 right: 10px;
//                 left: unset;
//                 pointer-events: all;
//                 cursor: pointer;
//             }
//         }
//     }
// `

const FilterContainer = styled.div`
    margin: 20px 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .typeButtonsGroup {
        display: flex;
        gap : 20px;
        justify-content: space-between;
        text-transform: uppercase;

        @media (max-width: 1000px) {
            width: 100%;
            gap: 10px;
        }

        span {
            font-size: 25px;
            font-weight: 500;
            cursor: pointer;
            border: 1px solid black;
            padding: 3px 25px;
            border-radius: 50px;

            @media (max-width: 1000px) {
                font-size: 14px;
                padding: 2px 10px;
                margin-bottom: 20px;
            }
        }

        .selected {
            background-color: black;
            color: white;
        }
    }

    .FiltersButton {
        display: flex;
        justify-content: right;
        gap: 40px;
        align-items: center;
        font-size: 16px;
        font-weight: 500;
        color: blue;
        cursor: pointer;
        width: 33%;

        @media (max-width: 1000px) {
            width: 100%;
        }

        > img {
            height: 30px;
        }
    }
`;

const AdvancedFiltersContainer = styled.div`
    display: flex;
    /* justify-content: space-around; */
    align-items: center;
    margin: 20px 0;
    gap: 20px;
    flex-wrap: wrap;

    select {
        width: 290px;
    }
`;

const Annuaire = (props) => {

    const urlParams = new URLSearchParams(window.location.search);
    const queryParam = urlParams.get('q');

    const filtersParam = urlParams.get('f') ? JSON.parse(atob(urlParams.get('f'))) : {type : "company"};

    const { i18n } = useTranslation('common');

    const [query, setQuery] = React.useState(queryParam || '');
    const [loading, setLoading] = React.useState(true);
    const [filtersDeployed, setFiltersDeployed] = React.useState(false);
    const [filters, setFilters] = React.useState(filtersParam);
    const [letterFilter, setLetterFilter] = React.useState("");
    const [allResults, setAllResults] = React.useState([]);
    
    const fullAccess = userHasFullAccess(props.fullUser, props.fullUserLoading)

    // console.log("fullAccess : " + fullAccess);

    React.useEffect(() => {
        //get active users
        setLoading(true);
        api.GetActiveUsers().then(res => {
            // console.log("activeUsers")
            const _activeUsers = res.data.map(user => {return {...user, resultType : "profile"}});
            // console.log(_activeUsers);
            const _companies = [];
            const _projects = [];

            for(let i = 0; i < _activeUsers.length; i++) {
                const user = _activeUsers[i];

                //for each user, add the company if the ids don't match
                if(user.company && !_companies.find(company => company.company._id === user.company.company._id)){
                    _companies.push({...user.company, resultType : "company"});

                    //for each company, add the projects
                    for(let j = 0; j < user.company.company.projects.length; j++) {
                        const project = user.company.company.projects[j];
                        project.companyid = user.company.company._id;
                        project.companyname = user.company.hsCompany?.properties?.name;
                        if(project.public){
                            _projects.push({...project, resultType : "project"});
                        }
                    }
                }
            }

            setAllResults([..._activeUsers,..._companies,..._projects])
            setLoading(false);
        }
        ).catch(function (error) {
            console.log(error);
        });
    },[]);

    React.useEffect(() => {
        if(!fullAccess && filters.type !== "company"){
            setFilters({type : "company"});
            setTimeout(() => alert(i18n.language === "fr" ? "Vous devez être membre de la communauté pour accéder aux profils et projets." : "You must be a member of the community to access profiles and projects."), 100);
        }
    },[fullAccess, filters.type]);

    async function search(search){
        setQuery(search);
    }

    function toggleFilters(){
        if(filtersDeployed){
            setFilters({type : filters.type});
        }
        setFiltersDeployed(!filtersDeployed);
    }

    // const searchInput = React.useRef(null);

    function filterByType(result){
        if(!filters.type) return true;
        return result.resultType === filters.type;
    }

    function filterBySearchQuery(result){

        // function to simplify a string by removing accents, space, dashes and special characters, making it lowercase and removing spaces
        function simplifyString(str){
            return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, "").replace(/-/g, "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
        }

        // function like 'inclueds' but that returns true if a character changed in the query
        function includesWithTypos(str, query){
            if(str.includes(query)) return true;
            
            // Helper function to calculate Levenshtein distance
            function levenshteinDistance(s1, s2) {
                const dp = Array(s1.length + 1)
                    .fill(null)
                    .map(() => Array(s2.length + 1).fill(0));

                for (let i = 0; i <= s1.length; i++) dp[i][0] = i;
                for (let j = 0; j <= s2.length; j++) dp[0][j] = j;

                for (let i = 1; i <= s1.length; i++) {
                    for (let j = 1; j <= s2.length; j++) {
                        const cost = s1[i - 1] === s2[j - 1] ? 0 : 1;
                        dp[i][j] = Math.min(
                            dp[i - 1][j] + 1, // deletion
                            dp[i][j - 1] + 1, // insertion
                            dp[i - 1][j - 1] + cost // substitution
                        );
                    }
                }

                return dp[s1.length][s2.length];
            }

            // Check for a match with a Levenshtein distance of 1 or less
            for (let i = 0; i <= str.length - query.length; i++) {
                const substring = str.slice(i, i + query.length);
                if (levenshteinDistance(query, substring) <= 1) return true;
            }

            return false;
        }


        if(!query) return true;
        const smiplifiedQuery = simplifyString(query);
        if(result.resultType === "profile" && result.hsProfile?.properties?.firstname && result.hsProfile?.properties?.lastname &&
            includesWithTypos(simplifyString((result.hsProfile.properties.firstname + " " + result.hsProfile.properties.lastname)),smiplifiedQuery)){
            return true;
        }

        // if(result.resultType === "profile" && result.hsProfile?.properties?.presentation_libre_en && result.hsProfile?.properties?.presentation_libre_fr &&
        //     (result.hsProfile.properties.presentation_libre_en.toLowerCase().includes(smiplifiedQuery) || result.hsProfile.properties.presentation_libre_fr.toLowerCase().includes(smiplifiedQuery))){
        //     return true;
        // }
        if(result.resultType === "company" && result?.hsCompany?.properties?.name && includesWithTypos(simplifyString(result.hsCompany.properties.name),smiplifiedQuery)){
            return true;
        }
        // if(result.resultType === "company" && result.hsCompany?.properties?.description_courte_en && result.hsCompany?.properties?.description_courte_fr &&
        //     (result.hsCompany.properties.description_courte_en.toLowerCase().includes(smiplifiedQuery) || result.hsCompany.properties.description_courte_fr.toLowerCase().includes(smiplifiedQuery))){
        //     return true;
        // }
        if(result.resultType === "project" && result.name && includesWithTypos(simplifyString(result.name),smiplifiedQuery)){
            return true;
        }
        // if(result.resultType === "project" && result.abouten && result.aboutfr &&
        //     (result.abouten.toLowerCase().includes(smiplifiedQuery) || result.aboutfr.toLowerCase().includes(smiplifiedQuery))){
        //     return true;
        // }
        return false;
    }

    // function filterByCountry(result){
    //     if(!filters.country) return true;
    //     if(result.resultType === "profile" && result.hsProfile?.properties?.country && result.hsProfile.properties.country === filters.country){
    //         return true;
    //     }
    //     if(result.resultType === "company" && result.hsCompany?.properties?.country && result.hsCompany.properties.country === filters.country){
    //         return true;
    //     }
    //     if(result.resultType === "project" && result.adresse && result.adresse.toLowerCase().includes(filters.country.toLowerCase())){
    //         return true;
    //     }
    //     return false;
    // }

    function filterByPositionnement(result){
        if(!filters.positionnement) return true;
        if(result.resultType === "profile" && result.hsProfile?.properties?.positionnement && result.hsProfile.properties.positionnement.includes(filters.positionnement)){
            return true;
        }
        if(result.resultType === "company" && result.hsCompany?.properties?.positionnement && result.hsCompany.properties.positionnement.includes(filters.positionnement)){
            return true;
        }
        return false;
    }

    function filterByTypologie(result){
        if(!filters.typologie) return true;
        if(result.resultType === "project" && result.typologie && result.typologie === filters.typologie){
            return true;
        }
        return false;
    }

    function filterByActivité(result){
        if(!filters.activité) return true;
        if(result.resultType === "profile" && result.hsProfile?.properties?.cat_gories_via && result.hsProfile.properties.cat_gories_via.includes(filters.activité)){
            return true;
        }
        if(result.resultType === "company" && result.hsCompany?.properties?.cat_gorie_via && result.hsCompany.properties.cat_gorie_via.includes(filters.activité)){
            return true;
        }
        return false;
    }

    function filterByClientèle(result){
        if(!filters.clientèle) return true;
        if(result.resultType === "profile" && result.hsProfile?.properties?.clientele && result.hsProfile.properties.clientele.includes(filters.clientèle)){
            return true;
        }
        if(result.resultType === "company" && result.hsCompany?.properties?.clientele && result.hsCompany.properties.clientele.includes(filters.clientèle)){
            return true;
        }
        return false;
    }

    function filterByProjectType(result){
        if(!filters.projectType) return true;
        if(result.resultType === "project" && result.type && result.type === filters.projectType){
            return true;
        }
        return false;
    }

    function filterByFabrication(result){
        if(!filters.fabrication_fr) return true;
        if(result.resultType === "project" && result.fabrication_fr === filters.fabrication_fr){
            return true;
        }
        return false;
    }

    function filterByLibreEdition(result){
        if(!filters.libre_edition) return true;
        if(result.resultType === "project" && result.type === "objet" && result.libre_edition === filters.libre_edition){
            return true;
        }
        return false;
    }

    function filterByFirstLetter(result){
        if(!letterFilter) return true;
        if(result.resultType === "profile" && result.hsProfile?.properties?.lastname && result.hsProfile.properties.lastname[0].toLowerCase() === letterFilter.toLowerCase()){
            return true;
        }
        if(result.resultType === "company" && result.hsCompany?.properties?.name && result.hsCompany.properties.name[0].toLowerCase() === letterFilter.toLowerCase()){
            return true;
        }
        if(result.resultType === "project" && result.name && result.name[0].toLowerCase() === letterFilter.toLowerCase()){
            return true;
        }

        return false;
    }

    function sortAlhabetically(a,b){

        function normalize(str){
            return replaceNumbersByZs(str).replace(/['"]+/g, '').trim()
        }

        function replaceNumbersByZs(str){
            return str.replace(/[0-9]/g, 'z');
        }

        if(a.resultType === "profile" && b.resultType === "profile"){
            if(a.hsProfile?.properties?.lastname && b.hsProfile?.properties?.lastname){
                return normalize(a.hsProfile.properties.lastname).localeCompare(normalize(b.hsProfile.properties.lastname));
            }
        }
        if(a.resultType === "company" && b.resultType === "company"){
            if(a.hsCompany?.properties?.name && b.hsCompany?.properties?.name){
                return normalize(a.hsCompany.properties.name).localeCompare(normalize(b.hsCompany.properties.name));
            }
        }
        if(a.resultType === "project" && b.resultType === "project"){
            if(a.name && b.name){
                return normalize(a.name).localeCompare(normalize(b.name));
            }
        }
        return 0;
    }

    function sortByPresenceOfAnImage(a,b){
        if(a.resultType === "profile" && b.resultType === "profile"){
            if(a.user.portrait && b.user.portrait){
                return 0;
            }
            if(a.user.portrait && !b.user.portrait){
                return -1;
            }
            if(!a.user.portrait && b.user.portrait){
                return 1;
            }
        }
        if(a.resultType === "company" && b.resultType === "company"){
            if(a.company.logo && b.company.logo){
                return 0;
            }
            if(a.company.logo && !b.company.logo){
                return -1;
            }
            if(!a.company.logo && b.company.logo){
                return 1;
            }
        }
        if(a.resultType === "project" && b.resultType === "project"){
            if(GetProjectMainImage(a) && GetProjectMainImage(b)){
                return 0;
            }
            if(GetProjectMainImage(a) && !GetProjectMainImage(b)){
                return -1;
            }
            if(!GetProjectMainImage(a) && GetProjectMainImage(b)){
                return 1;
            }
        }
        return 0;
    }

    return (
        <div>
            <Section className="padding">
                {/* <BigH1>{i18n.language === "fr" ? "L'ANNUAIRE" : "THE"}<br/>{i18n.language === "fr" ? "DE LA" : "COMMUNITY"}<br/>{i18n.language === "fr" ? "COMMUNAUTÉ" : "DIRECTORY"}</BigH1><br/><br/> */}
                <BigH1>{i18n.language === "fr" ? "L'ANNUAIRE DE" : "THE COMMUNITY"}<br/>{i18n.language === "fr" ? "LA COMMUNAUTÉ" : "DIRECTORY"}</BigH1><br/><br/>
                <span style={{fontSize:"22px"}}>{i18n.language === "fr" ? "Découvrez et accédez aux membres de la Communauté Le FRENCH DESIGN." : "Discover and access the members of Le FRENCH DESIGN Community."}</span>
            </Section>
            <Section className='padding'>
                <Searchbar searchFieldContent={queryParam} onsearch={search} bigmode/>
                {/* <SearchFieldContainer lang={i18n.language} searchFieldContent={searchFieldContent}>
                    <form onSubmit={search} style={{width:'100%'}}>
                        <input ref={searchInput} onChange={e => setSearchFieldContent(e.target.value)} style={{width:'100%'}} placeholder={i18n.language === "fr" ? "Rechercher..." : "Search..."} defaultValue={query}/>
                        <img src='/img/loupe_bleue.png' alt='search'/>
                        <img onClick={search} className='loupe-mobile' src='/img/loupe_bleue.png' alt='search'/>
                    </form>
                </SearchFieldContainer> */}
                <FilterContainer>
                    <div className='typeButtonsGroup'>
                        <span onClick={() => setFilters({type : "profile"})} className={filters.type === "profile" ? "selected" : null}>{i18n.language === "fr" ? "Profils" : "Profiles"}</span>
                        <span onClick={() => setFilters({type : "company"})} className={filters.type === "company" ? "selected" : null}>{i18n.language === "fr" ? "Sociétés" : "Companies"}</span>
                        <span onClick={() => setFilters({type : "project"})} className={filters.type === "project" ? "selected" : null}>{i18n.language === "fr" ? "Projets" : "Projects"}</span>
                    </div>
                    <div className='FiltersButton' onClick={toggleFilters}>
                        {filtersDeployed ? <><span>{i18n.language === "fr" ? "Effacer les filtres" : "Clear filters"}</span><img src='/img/x_bleu_grand.png' alt=""/></>
                        : <><span>{i18n.language === "fr" ? "Affiner la recherche" : "Refine search"}</span><img src='/img/filtres.png' alt=""/></>}
                    </div>
                </FilterContainer>
                {filtersDeployed &&
                    <AdvancedFiltersContainer>
                        {filters.type === "project" && <Select onChange={(event) => setFilters({...filters, projectType : event.target.value})}>
                            <option value="">{i18n.language === "fr" ? "Type de projet" : "Project type"}</option>
                            <option value="objet">{i18n.language === "fr" ? "Objet" : "Object"}</option>
                            <option value="espace">{i18n.language === "fr" ? "Espace" : "Space"}</option>
                        </Select>}
                        {filters.type === "project" && <Select onChange={(event) => setFilters({...filters, typologie : event.target.value})}>
                            <option value="">{i18n.language === "fr" ? "Typologie" : "Typologie"}</option>
                            {filters.projectType !== "objet" && typologiesEspace.filter(typ => typ.code !== "autre").map((typologie) => {
                                return <option key={typologie.code} value={typologie.code}>{i18n.language === "fr" ? typologie.fr : typologie.en}</option>
                            })}
                            {filters.projectType !== "espace" && typologiesObjet.filter(typ => typ.code !== "autre").map((typologie) => {
                                return <option key={typologie.code} value={typologie.code}>{i18n.language === "fr" ? typologie.fr : typologie.en}</option>
                            })}
                        </Select>}
                        {filters.type === "project" && <Select onChange={(event) => setFilters({...filters, fabrication_fr : event.target.value})}>
                            <option value="">{i18n.language === "fr" ? "Fabrication française" : "French manufacturing"}</option>
                            <option value="oui">{i18n.language === "fr" ? "Oui" : "Yes"}</option>
                            <option value="non">{i18n.language === "fr" ? "Non" : "No"}</option>
                        </Select>}
                        {filters.type === "project" && <Select onChange={(event) => setFilters({...filters, libre_edition : event.target.value})}>
                            <option value="">{i18n.language === "fr" ? "Libre à l'édition" : "Free to edit"}</option>
                            <option value="oui">{i18n.language === "fr" ? "Oui" : "Yes"}</option>
                            <option value="non">{i18n.language === "fr" ? "Non" : "No"}</option>
                        </Select>}
                        {/* <Select onChange={(event) => setFilters({...filters, country : event.target.value})}>
                            <option value="">{i18n.language === "fr" ? "Tous les pays" : "All countries"}</option>
                            <CountrySelectOptions/>
                        </Select> */}
                        {filters.type === "company" && <Select onChange={(event) => setFilters({...filters, activité : event.target.value})}>
                            <option value="">{i18n.language === "fr" ? "Activité de l’entreprise" : "Company activity"}</option>
                            <option value="Donneur d'ordre">{i18n.language === "fr" ? "Donneur d'ordre /prescripteur" : "Client / prescriber"}</option>
                            <option value="Créateur - Architecte">{i18n.language === "fr" ? "Architecte" : "Architect"}</option>
                            <option value="Créateur - Designer objet">{i18n.language === "fr" ? "Designer objet" : "Object designer"}</option>
                            <option value="Créateur - Designer espace">{i18n.language === "fr" ? "Architecte d'intérieur" : "Interior designer"}</option>
                            <option value="Créateur - Graphiste">{i18n.language === "fr" ? "Graphiste" : "Graphic designer"}</option>
                            <option value="Créateur - Scénographe">{i18n.language === "fr" ? "Scénographe" : "Set designer"}</option>
                            <option value="Créateur - Stratégie de marque">{i18n.language === "fr" ? "Créateur Stratégie de marque" : "Brand strategy designer"}</option>
                            <option value="Créateur - Stratégie digitale">{i18n.language === "fr" ? "Créateur Stratégie digitale" : "Digital strategy designer"}</option>
                            <option value="Producteur -  Galerie">{i18n.language === "fr" ? "Galeriste" : "Gallery"}</option>
                            <option value="Producteur - Equipementier / Matériaux">{i18n.language === "fr" ? "Équipementier / matériaux" : "Equipment / materials"}</option>
                            <option value="Producteur - Agenceur">{i18n.language === "fr" ? "Agenceur" : "Fitter"}</option>
                            <option value="Producteur - Artisan d'art">{i18n.language === "fr" ? "Artisan d'art" : "Craftsman"}</option>
                            <option value="Producteur - Editeur">{i18n.language === "fr" ? "Éditeur" : "Editor"}</option>
                            <option value="Producteur - Fabricant">{i18n.language === "fr" ? "Fabricant" : "Manufacturer"}</option>
                            <option value="Producteur - Distributeur">{i18n.language === "fr" ? "Distributeur" : "Distributor"}</option>
                            {/*<option value="Producteur - Autres">{i18n.language === "fr" ? "Autre producteur" : "Other producer"}</option>
                            <option value="Presse">{i18n.language === "fr" ? "Presse" : "Press"}</option>*/}
                            {/* <option value="Institutionnel">{i18n.language === "fr" ? "Institutionnel" : "Institutional"}</option>
                            <option value="Institutionnel - Ecole">{i18n.language === "fr" ? "Institutionnel - école" : "Institutional - school"}</option>
                            <option value="Institutionnel - Consulat / ambassade">{i18n.language === "fr" ? "Institutionnel - consulat / ambassade" : "Institutional - consulate / embassy"}</option>
                            <option value="Institutionnel - Musée / centre d'art">{i18n.language === "fr" ? "Institutionnel - musée / centre d'art" : "Institutional - museum / art center"}</option>
                            <option value="Institutionnel - Salon / foire">{i18n.language === "fr" ? "Institutionnel - salon / foire" : "Institutional - trade show / fair"}</option> */}
                            {/*<option value="Autres">{i18n.language === "fr" ? "Autre" : "Other"}</option>*/}
                        </Select>}
                        {filters.type === "profile" && <Select onChange={(event) => setFilters({...filters, activité : event.target.value})}>
                            <option value="">{i18n.language === "fr" ? "Activité professionnelle" : "Professional activity"}</option>
                            {/* <option value="Donneur d'ordre">{i18n.language === "fr" ? "Donneur d'ordre /prescripteur" : "Client / prescriber"}</option> */}
                            <option value="Créateur - Architecte">{i18n.language === "fr" ? "Architecte" : "Architect"}</option>
                            <option value="Créateur - Designer objet">{i18n.language === "fr" ? "Designer objet" : "Object designer"}</option>
                            <option value="Créateur - Designer espace">{i18n.language === "fr" ? "Architecte d'intérieur" : "Interior designer"}</option>
                            <option value="Créateur - Graphiste">{i18n.language === "fr" ? "Graphiste" : "Graphic designer"}</option>
                            <option value="Créateur - Scénographe">{i18n.language === "fr" ? "Scénographe" : "Set designer"}</option>
                            <option value="Créateur - Stratégie de marque">{i18n.language === "fr" ? "Créateur Stratégie de marque" : "Brand strategy designer"}</option>
                            <option value="Créateur - Stratégie digitale">{i18n.language === "fr" ? "Créateur Stratégie digitale" : "Digital strategy designer"}</option>
                            <option value="Producteur -  Galerie">{i18n.language === "fr" ? "Galeriste" : "Gallery"}</option>
                            <option value="Producteur - Equipementier / Matériaux">{i18n.language === "fr" ? "Équipementier / matériaux" : "Equipment / materials"}</option>
                            <option value="Producteur - Agenceur">{i18n.language === "fr" ? "Agenceur" : "Fitter"}</option>
                            <option value="Producteur - Artisan d'art">{i18n.language === "fr" ? "Artisan d'art" : "Craftsman"}</option>
                            <option value="Producteur - Editeur">{i18n.language === "fr" ? "Éditeur" : "Editor"}</option>
                            <option value="Producteur - Fabricant">{i18n.language === "fr" ? "Fabricant" : "Manufacturer"}</option>
                            <option value="Producteur - Distributeur">{i18n.language === "fr" ? "Distributeur" : "Distributor"}</option>
                            {/* <option value="Producteur - Autres">{i18n.language === "fr" ? "Autre producteur" : "Other producer"}</option> */}
                            {/* <option value="Presse">{i18n.language === "fr" ? "Presse" : "Press"}</option> */}
                            {/* <option value="Institutionnel">{i18n.language === "fr" ? "Institutionnel" : "Institutional"}</option> */}
                            {/* <option value="Institutionnel - Ecole">{i18n.language === "fr" ? "Institutionnel - école" : "Institutional - school"}</option> */}
                            {/* <option value="Institutionnel - Consulat / ambassade">{i18n.language === "fr" ? "Institutionnel - consulat / ambassade" : "Institutional - consulate / embassy"}</option> */}
                            {/* <option value="Institutionnel - Musée / centre d'art">{i18n.language === "fr" ? "Institutionnel - musée / centre d'art" : "Institutional - museum / art center"}</option> */}
                            {/* <option value="Institutionnel - Salon / foire">{i18n.language === "fr" ? "Institutionnel - salon / foire" : "Institutional - trade show / fair"}</option> */}
                            {/* <option value="Autres">{i18n.language === "fr" ? "Autre" : "Other"}</option> */}
                        </Select>}
                        {filters.type === "company" && <Select onChange={(event) => setFilters({...filters, positionnement : event.target.value})}>
                            <option value="">{i18n.language === "fr" ? "Positionnement" : "Positioning"}</option>
                            {positionnements.map((positionnement) => 
                                <option key={positionnement.code} value={positionnement.code}>{i18n.language === "fr" ? positionnement.fr : positionnement.en}</option>
                            )}
                        </Select>}
                        {filters.type === "company" && <Select onChange={(event) => setFilters({...filters, clientèle : event.target.value})}>
                            <option value="">{i18n.language === "fr" ? "Clientèle" : "Customer base"}</option>
                            {clientèles.map((clientèle) =>
                                <option key={clientèle.code} value={clientèle.code}>{i18n.language === "fr" ? clientèle.fr : clientèle.en}</option>
                            )}
                        </Select>}
                    </AdvancedFiltersContainer>
                }
            </Section>
            <Section className='padding'>
                {loading ? <><br/><br/><br/><Spinner/><br/><br/><br/><br/><br/><br/><br/><br/><br/></> : <>
                    <br/><br/>
                    <Results results={
                        allResults
                        .filter(filterByType)
                        .filter(filterBySearchQuery)
                        // .filter(filterByCountry)
                        .filter(filterByPositionnement)
                        .filter(filterByTypologie)
                        .filter(filterByActivité)
                        .filter(filterByClientèle)
                        .filter(filterByProjectType)
                        .filter(filterByFabrication)
                        .filter(filterByLibreEdition)
                        .filter(filterByFirstLetter)
                        .sort(sortAlhabetically)
                        .sort(sortByPresenceOfAnImage)
                    } resultsType={filters.type} setLetterFilter={setLetterFilter} letterFilter={letterFilter} totalUnfiltered={allResults.filter(filterByType).length} />
                </>}
            </Section>
        </div>
    );
};

const Results = (props) => {

    const { i18n } = useTranslation('common');

    // console.log("props.results")
    // console.log(props.results)

    let heading = i18n.language === "fr" ? "Résultats" : "Search"
    if(props.resultsType === "profile") heading = i18n.language === "fr" ? "Profils" : "Profiles";
    if(props.resultsType === "company") heading = i18n.language === "fr" ? "Sociétés" : "Companies";
    if(props.resultsType === "project") heading = i18n.language === "fr" ? "Projets" : "Projects";

    const total = props.results.length;
    const totalUnfiltered = props.totalUnfiltered;

    return (
        <div>
            <H1>
                {heading}&nbsp;<span style={{fontWeight:"400",fontSize:"25px",color:"blue"}}>({total === totalUnfiltered ? totalUnfiltered : total + "/" + totalUnfiltered})</span>
            </H1><br/><br/>
            <div style={{display:"flex",justifyContent:"space-between",gap:"10px"}}>
                {props.results.length === 0 && <span>{i18n.language === "fr" ? "Aucun résultat." : "No result."}</span>}
                {props.results.length > 0 && <>
                    <AlphabetSelector setLetterFilter={props.setLetterFilter} letterFilter={props.letterFilter}/>
                    <div style={{width:"100%"}}>
                        <MiniatureContainer>
                            {props.results.map((result) => {

                                if(result.resultType === "profile") return (
                                    <Link to={"/profile?id=" + btoa(result.user.email)} key={result.user._id}>
                                        <Miniature
                                            imagePath={result.user.portrait && (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + result.user.portrait)}
                                            title={result.hsProfile?.properties.firstname + " " + result.hsProfile?.properties.lastname}
                                            tag={i18n.language === "fr" ? "Profil" : "Profile"}
                                            //no privacy
                                            keyInfo={result.hsProfile?.properties && CityCommaCountry(result.hsProfile?.properties)}
                                            category={result.hsProfile?.properties?.jobtitle}
                                            />  
                                    </Link>
                                );

                                if(result.resultType === "company") return (
                                    <Link to={"/company?id=" + result.company._id} key={result.company._id}>
                                        <Miniature
                                            imagePath={result.company.logo && (process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + result.company.logo)}
                                            title={result.hsCompany?.properties?.name}
                                            tag={i18n.language === "fr" ? "Société" : "Company"}
                                            //no privacy
                                            keyInfo={result.hsCompany?.properties && CityCommaCountry(result.hsCompany?.properties)}
                                            category={FormatActivité(result.hsCompany?.properties?.cat_gorie_via, i18n.language)}
                                            objectFit="contain"
                                        />
                                    </Link>
                                );
                                
                                if(result.resultType === "project"){
                                    if(result.type === "objet") return (
                                        <Link to={"/project?pid=" + result._id + "&cid=" + result.companyid} key={result._id}>
                                            <Miniature
                                                imagePath={GetProjectMainImage(result)}
                                                title={result.name}
                                                subtitle={result.companyname}
                                                tag={i18n.language === "fr" ? "Projet" : "Project"}
                                                //no privacy
                                                keyInfo={result.adresse}
                                                category={result.libre_edition === "oui" ? (i18n.language === "fr" ? "Libre à l'édition" : "Free to edit") : result.editeur}
                                            />
                                        </Link>
                                    ); return (
                                        <Link to={"/project?pid=" + result._id + "&cid=" + result.companyid} key={result._id}>
                                            <Miniature
                                                imagePath={GetProjectMainImage(result)}
                                                title={result.name}
                                                subtitle={result.companyname}
                                                tag={i18n.language === "fr" ? "Projet" : "Project"}
                                                //no privacy
                                                keyInfo={result.adresse}
                                                category={result.fabrication_fr === "oui" ? (i18n.language === "fr" ? "Fabrication française" : "French manufacturing") : null}
                                            />
                                        </Link>
                                    );
                                }

                                return null;
                            })}
                        </MiniatureContainer>
                    </div>
                </>}
            </div>
        </div>
    );
}

const AlphabetSelector = (props) => {

    const { i18n } = useTranslation('common');

    const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

    const selectedStyle = {
        color:"black",
        fontSize:"14px"
    }

    const unselectedStyle = {
        cursor:"pointer",
        color:"#bababa",
        fontSize:"10px"
    }
    return (
        <div style={{display:"flex",flexDirection:"column",flexWrap:"nowrap",position:"sticky",top:"20px",alignItems:"center",alignSelf:"flex-start",height:"calc(100dvh - 20px)",justifyContent:"space-between"}}>
            <div style={props.letterFilter === "" ? selectedStyle : unselectedStyle} onClick={() => props.setLetterFilter("")}>{i18n.language === "fr" ? "Tout" : "All"}</div>
            {alphabet.map(letter => 
                <div key={letter} style={props.letterFilter === letter ? selectedStyle : unselectedStyle} onClick={() => props.setLetterFilter(letter)}>{letter}</div>
            )}
        </div>
    );
}

export default Annuaire;